import {AfterViewInit, ChangeDetectorRef, Component} from "@angular/core";
import {ConfigurationService, provideEntityModel} from "@fedeltapointofsale/data-client";
import {LocationEntityModel} from "../location-entity.model";
import {Config, License} from "../../../config";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {FormControl} from "@angular/forms";
import {
    FUIAlertAction,
    FUIAlertActions,
    FUIAlertService,
    FUIResponsiveService,
    FUISpinnersService
} from "@fedeltapointofsale/ui";
import {first, Subscription, timer} from "rxjs";
import {
    LocationRequestTyroDeviceCodeActionResult,
    LocationRequestTyroDeviceCodeService
} from "../location-request-tyro-device-code.service";
import {
    LocationRequestTyroRefreshTokenAction,
    LocationRequestTyroRefreshTokenActionResult,
    LocationRequestTyroRefreshTokenService
} from "../location-request-tyro-refresh-token.service";

@Component({
    selector: "wbo-location-edit-page",
    templateUrl: "./location-edit-page.component.html",
    providers: [provideEntityModel(LocationEntityModel), LocationRequestTyroDeviceCodeService, LocationRequestTyroRefreshTokenService]
})
export class LocationEditPageComponent extends AbstractEditPage implements AfterViewInit {
    License = License;

    clientId: string;

    private tyroConnectRequestDeviceTokenSubscription: Subscription;

    tyroConnectRequestRefreshTokenUpdated: boolean;

    constructor(public model: LocationEntityModel,
                private configurationService: ConfigurationService,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService,
                private spinnersService: FUISpinnersService,
                private alertService: FUIAlertService,
                private locationGenerateTyroDeviceCodeService: LocationRequestTyroDeviceCodeService,
                private locationTerminalRequestTyroAccessTokenService: LocationRequestTyroRefreshTokenService) {
        super(changeDetectorRef, responsiveService);
        this.configurationService.getString(Config.CLIENT_ID).then((value: string) => this.clientId = value);
    }

    ngAfterViewInit() {
        this.editPageComponent.editService.formGroup.addControl("fedeltaRestaurantId", new FormControl());
    }

    get fedeltaRestaurantId(): string {
        return this.clientId && this.model.data.outletGroupId ? this.clientId + "/" + this.model.data.outletGroupId : "";
    }

    set fedeltaRestaurantId(value: string) {
    }

    async authenticateTyro() {
        await this.spinnersService.open();
        let codeResult: LocationRequestTyroDeviceCodeActionResult;
        try {
            codeResult = await this.locationGenerateTyroDeviceCodeService.performAction({});
        } finally {
            this.spinnersService.close();
        }
        const action: FUIAlertAction = await this.alertService.showConfirmationOkCancel("wbo.web-terminal.edit.prompt.confirmTyroAuthentication.heading",
            "wbo.web-terminal.edit.prompt.confirmTyroAuthentication.message").toPromise();
        if (action === FUIAlertActions.OK_ACTION) {
            this.initAuthenticationTyroPool(codeResult);
            window.open(codeResult.verification_uri_complete);
        }
    }

    initAuthenticationTyroPool(code: LocationRequestTyroDeviceCodeActionResult): void {
        this.tyroConnectRequestDeviceTokenSubscription = timer(code.interval * 1000).pipe(first()).subscribe(async () => {
            const result: LocationRequestTyroRefreshTokenActionResult = await this.locationTerminalRequestTyroAccessTokenService.performAction(new LocationRequestTyroRefreshTokenAction(code.device_code));
            if (result.refreshToken) {
                this.model.data.tyroConnectRefreshToken = result.refreshToken;
                this.tyroConnectRequestDeviceTokenSubscription = null;
                this.tyroConnectRequestRefreshTokenUpdated = true;
            } else {
                this.initAuthenticationTyroPool(code);
            }
        });
    }

    cancelAuthenticationTyroPool(): void {
        if (this.tyroConnectRequestDeviceTokenSubscription) {
            this.tyroConnectRequestDeviceTokenSubscription.unsubscribe();
            this.tyroConnectRequestDeviceTokenSubscription = null;
        }
    }

    get requestingAccessToken(): boolean {
        return this.tyroConnectRequestDeviceTokenSubscription != undefined;
    }
}
